import { render } from "./Budgets.vue?vue&type=template&id=4d6809a0&scoped=true"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"

import "./Budgets.vue?vue&type=style&index=0&id=4d6809a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6809a0"]])

export default __exports__